<div class="wrapper">
	<div *ngIf="caretPosition" class="caret" [ngClass]="caretPosition + '-caret'"></div>
	<div *ngIf="showBadge" class="new ds-flex-center-center ds-py-5 ds-px-0 ds-mb-20">NEW</div>
	<div class="info ds-mb-20" [ngClass]="{ 'ds-mt-10': !showBadge }">{{ description }}</div>
	<div class="buttons ds-flex-end-end">
		<app-gradient-button *ngIf="link" gradient="#70819f, #70819f" [buttonLink]="link" [text]="learnMoreText"></app-gradient-button>
		<app-gradient-button style="margin-left: 10px" (buttonClick)="gotItEvent.emit(true)">{{ dismissText }}</app-gradient-button>
	</div>
</div>
